import React from 'react'
import { Container, Header, Button, List, Segment, Image, Menu } from 'semantic-ui-react'
import { ROUTES } from '../navigation/routes'

class LandingPage extends React.Component {



    render() {
        const { mobile } = this.props
        return (
            <div>
                <Segment
                    //inverted
                    textAlign='center'
                    style={{ minHeight: 600, padding: '1em 0em' }}
                    vertical
                    //backgroundImage='/images/houseplant.JPG '
                >
                    {/* <Menu
                        fixed
                        inverted
                        //pointing
                        secondary
                        size='large'
                    >
                        <Container>

                            <Menu.Item position='right'>
                                <Button primary as='a' href='/signin' >
                                    Administrator access
                                </Button>

                            </Menu.Item>
                        </Container>
                    </Menu> */}
                    <Container text>


                        <Header
                            as='h1'
                            //content='Plant Hospital'
                            //inverted
                            style={{
                                fontSize: mobile ? '2em' : '4em',
                                fontWeight: 'normal',
                                marginBottom: 0,
                                //marginTop: mobile ? '1.5em' : '3em',
                            }}
                        >
                            <Image src='/ph_app_icon.png' />
                            <br /><br />
                        Plant Hospital
                        </Header>
                        <Header
                            as='h2'
                            content='The online consultation tool for plants'
                            //inverted
                            style={{
                                fontSize: mobile ? '1.5em' : '1.7em',
                                fontWeight: 'normal',
                                marginTop: mobile ? '0.5em' : '1.5em',
                            }}
                        />
                        <List horizontal>
                            <List.Item as='a' href='https://play.google.com/store/apps/details?id=com.torosmarkett.plantHospital' target='_blank' >
                                <Image src='/images/google-play.JPG' style={{ height: 40 }} />
                            </List.Item>
                            <List.Item as='a' href='https://apps.apple.com/us/app/planthospital/id1495570384?ls=1' target='_blank' >
                                <Image src='/images/app-store.JPG' style={{ height: 40 }} />
                            </List.Item>
                        </List>
                    </Container>

                </Segment>
                <Segment inverted vertical style={{ margin: '0em 0em 0em', padding: '5em 0em' }}>
                <Container text textAlign='center'>
                    <List horizontal inverted divided link size='small'>
                    <List.Item as='a' href='/signin'>
                        Administrator
                    </List.Item>
                    <List.Item as='a' href='mailto:support@tampaplanthospital.com' target='_black'>
                        Contact Us
                    </List.Item>
                    <List.Item as='a' href={ROUTES.TERMS_CONDITIONS}>
                        Terms and Conditions
                    </List.Item>
                    <List.Item as='a' href={ROUTES.PRIVACY_POLICY}>
                        Privacy Policy
                    </List.Item>
                    </List>
                    </Container>
                </Segment>
            </div>
        )
    }
}
export default LandingPage